import React, {useEffect, useState} from "react";
import Button from "reactstrap/lib/Button";
import Modal from "reactstrap/lib/Modal";
import ModalBody from "reactstrap/lib/ModalBody";
import ModalHeader from "reactstrap/lib/ModalHeader";
import ExitIcon from './img/Exclusion 2.svg'
import EditIcon from './img/edit-2-light.svg'
import modalBody from "./ModalData/ModalBody"
import returnTitle from './ModalData/Title';
import {t} from "react-switch-lang";
import './Modals.css';

export function Show(props) {
    const userModal = () => props.setModal(!props.modal);
    const [disabled, setDisabled] = useState(true);
    const [dataId, setDataId] = useState(null);

    const body = () => {
        const MyComponent = modalBody(dataId).show;
        if (MyComponent !== null) {
            return <MyComponent data={props.data} disabled={disabled}
                                setDisabled={() => setDisabled(true)}
                                toggleModal={() => props.setModal(false)}
                                isEditable={props.isEditable}
                                setRowChanged={() => props.setRowChanged()}/>
        } else {
            return ''
        }
    };

    useEffect(() => {
        setDataId(props.id);
        return () => {
            setDisabled(true);
            setDataId(null)
        };
    }, []);

    return (
        <>
            <Modal isOpen={props.modal} toggle={userModal}
                   className="modal-lg modal-show" backdrop="static">
                <ModalHeader toggle={userModal}>
                    <b>{t('buttons.review')} {returnTitle(props.id, props.data).toLowerCase()}</b>
                    <div>
                    {disabled && props.isEditable && !(props.type === 'user' && props.data.activated === false) &&
                        <Button className="on-edit-btn position-relative"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setDisabled(false)
                                }}>
                            <img src={EditIcon} alt="Edit icon"/>
                            <span className="edit-tooltip">
                        {t('buttons.editBtn')}
                        </span>
                        </Button>
                        }
                        <Button className="p-0 border-none" onClick={(e) => {
                            e.preventDefault();
                            props.setModal(false)
                        }} style={{
                            backgroundColor: 'transparent',
                            border: 'none'
                        }}>
                            <img src={ExitIcon} alt="Exit"/>
                        </Button>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {body()}
                </ModalBody>
            </Modal>
        </>
    );
}
